import { tempMeeApi } from '~/services/api';
import type { ISignInRequest } from '../types/ISignInRequest';
import type { ISignInResponse } from '../types/ISignInResponse';

interface ICreateSessionApiResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number | string;
}

// Gateway wraps auth-service responses in { data: { ... } }.
interface ICreateSessionApiEnvelope {
  data: ICreateSessionApiResponse;
}

export const signIn = async (payload: ISignInRequest): Promise<ISignInResponse> => {
  const { data: envelope } = await tempMeeApi.post<ICreateSessionApiEnvelope>(
    '/auth-service/sessions',
    payload,
  );
  const session = envelope.data;
  return {
    access_token: session.accessToken,
    refresh_token: session.refreshToken,
    expires_in: String(session.expiresIn),
  };
};
